import { render, staticRenderFns } from "./RevenueDistribution.vue?vue&type=template&id=820fb5ec"
import script from "./RevenueDistribution.vue?vue&type=script&lang=js"
export * from "./RevenueDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports